/* eslint-disable max-lines-per-function */
import { auth } from "@/util/firebase";
import { onAuthStateChanged, User } from "firebase/auth";
import { defineStore } from "pinia";
import { computed, ref } from "vue";
import type { DataInstance } from "@busy-human/gearbox";
import { Userspaces } from "@busy-human/k9-library";



export const useUserspace = defineStore('userspaces', () => {

    const users = ref<{[id: string]: DataInstance<Userspaces.Model>}>({});
    const authstate = ref<'waiting' | 'unauth' | 'ready'>('waiting');
    const userref = ref<User | null>(null);

    const selectedItem = ref<Userspaces.Model>(Userspaces.Defaults());
    const selectedId = ref<string>("");

    const asArray = computed<DataInstance<Userspaces.Model>[]>(() => Object.values(users.value));


    // async function deleteUserspace(id: string) {
    //     if (userref.value) {
    //         try {
    //             await Userspaces.Collection.deleteDoc(id);
    //         } catch (e) {
    //             console.error(e);
    //         }
    //     }
    //     delete users.value[id];
    // }

    async function createUserspace(customer: Userspaces.Model) {
        console.log("hit new userspace", customer);
        const newUserRef = await Userspaces.Collection.add(customer);

        const newUser = {
            ...newUserRef.data(),
            $id: newUserRef.$id
        };

        users.value[newUser.$id] = newUser;

        return newUser;
    }

    async function refresh() {
        const existing = await Userspaces.Collection.all().fetch();

        const tmp: typeof users.value = {};
        for(const remote of existing) {
            const tmpUser = {
                ...remote.data(),
                $id: remote.$id
            };
            tmp[remote.$id] = tmpUser;
        }
        users.value = { ...tmp };
    }
    // refresh();

    // ONCE YOU ADD AUTH BACK INTO THE PROJECT REMOVE THE ABOVE refresh() AND UNCOMMENT OUT THE BELLOW
    onAuthStateChanged(auth, async user => {
        if(user) {
            await refresh();
            authstate.value = 'ready';
        } else {
            users.value = {};
            authstate.value = 'unauth';
        }
    });


    async function editCustomer(userId: string, user: Userspaces.Model) {
        const tmp: Userspaces.Model = {...user};
        if('$id' in tmp) {
            delete (tmp as any).$id;
        }

        await Userspaces.Collection.docEntity(userId).update(tmp);
        users.value[userId] = {$id: userId, ...tmp};
        return userId;
    }





    return {
        users,
        authstate,
        userref,
        selectedItem,

        asArray,

        createUserspace,
        refresh,
        onAuthStateChanged,

        editCustomer,

    };
});






